// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('customerinvoice.customerinvoicerowsearch', {
        url: '/customerinvoicerowsearch',
        templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicerowsearch.tpl.html',
        controller: 'CustomerInvoiceRowSearchController as vm',
        params: {
            searchTerm: ''
        }
    });
}

// @ngInject
function CustomerInvoiceRowSearchController($state, $stateParams, $window, $scope, $translate, CustomerInvoiceApiService, loadSpinnerService, ResourcesService, AuthService) {
    var vm = this;

    //Properties
    vm.customerInvoices = [];
    vm.searchTerm = {};
    vm.searchTerm.term =  ($stateParams.searchTerm) ? $stateParams.searchTerm : '';
    vm.searchTerm.createdDateMin = new Date();
    vm.searchTerm.createdDateMax = new Date();

    vm.createdMinEndDate = new Date(2020, 1, 1);
    vm.createdMaxEndDate = new Date(2020, 1, 1);

    vm.searchTerm.invoiceTypes = [];
    vm.currentPage = 1;
    vm.totalItems = 0;
    vm.itemsPerPage = 15;
    vm.selectedInvoiceRow = {};
    vm.canAccess = AuthService.canAccess;
    vm.showSearchFields = true;
    vm.dueDate = '';
    vm.invoiceRowDate = '';

    //Public methods
    vm.loadCustomerInvoiceRows = loadCustomerInvoiceRows;
    vm.searchTermChange = searchTermChange;
    vm.selectInvoiceRow = selectInvoiceRow;
    vm.toggleSearchFields = toggleSearchFields;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getTypeTranslation = getTypeTranslation;
    vm.resetFilters = resetFilters;
    vm.goToCompleteInvoices = goToCompleteInvoices;

    activate();

    function activate() {
        loadCustomerInvoiceRows();
        $scope.$watch(function () {
            return vm.searchTerm.createdDateMin + vm.searchTerm.createdDateMax;
        }, function () {
            searchTermChange();
        });
    }

    function loadCustomerInvoiceRows() {
        loadSpinnerService.start('mainSpinner');
        CustomerInvoiceApiService.getAllUnboundInvoiceRow(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function (response) {
            vm.customerInvoiceRows = response;
            vm.totalItems = response.totalItems;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function searchTermChange() {
        $state.go('customerinvoice.customerinvoicerowsearch');
        vm.currentPage = 1;
        vm.showBackButton = false;
        loadCustomerInvoiceRows();
    }

    function selectInvoiceRow(invoiceRowId) {
        var invoiceRow = _.find(vm.customerInvoiceRows, function (invoiceRow) {
            return invoiceRow.id === invoiceRowId;
        });

        if (invoiceRow !== null) {
            vm.selectedInvoiceRow = invoiceRow;
            vm.totalItems = 1;
            vm.showSearchFields = false;
        }
    }

    function goToCompleteInvoices() {
        $state.go('customerinvoice.customerinvoicesearch');
    }

    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function getStatusTranslation(text) {
        return $translate.instant('customerinvoice.status' + text);
    }

    function getTypeTranslation(text) {
        return $translate.instant('customerinvoice.type' + text);
    }

    function resetFilters() {
        vm.searchTerm.createdDateMin = new Date();
        vm.searchTerm.createdDateMax = new Date();
        vm.searchTerm.term = '';
    }
}

angular
    .module('customerinvoice.customerinvoicerowsearch', [])
    .config(stateConfig)
    .controller('CustomerInvoiceRowSearchController', CustomerInvoiceRowSearchController);
